var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultMetalCupMaterialTransform, } from "3d/types";
/** ---------------   **/
/**    BXF Family     **/
/** ---------------   **/
export var suctionCupsFamilyBXF = {
    BXF: __assign(__assign({ cupModelName: "BXF75P", cupWidth: 0.075, cupHeight: 0.075 }, defaultMetalCupMaterialTransform.PU55), { fittingModelName: "G38M50" }),
};
